import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { ServiceWorkerModule } from '@angular/service-worker';
import {
  AUTO_CATCH_CONFIG,
  HttpErrorHandler,
  HttpErrorInterceptor,
  InactiveEnterpriseErrorHandler,
  InterceptorConfig
} from '@eceos/arch';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { AppRoutes } from './app.routes';
import { CoreModule } from './core/core.module';
import { FeaturesModule } from './features/features.module';
import { LoginModule } from './login/login.module';
import { SharedModule } from './shared/shared.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    SharedModule,
    CoreModule,
    AppRoutes,
    FeaturesModule,
    LoginModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    HammerModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: AUTO_CATCH_CONFIG, useValue: InterceptorConfig.NO_INTERCEPT },
    { provide: HttpErrorHandler, useClass: InactiveEnterpriseErrorHandler, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
